import NextImage, { ImageProps } from 'next/image';
import { FC } from 'react';

const Image: FC<ImageProps> = (props) => (
  <NextImage unoptimized={process.env.NODE_ENV === 'development'} {...props} />
);

export default Image;
